import API_URL from '../config';
const API = `${API_URL}/api`;

function authHeaders() {
  const token = localStorage.getItem('projabze_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/**
 * Fetch discipline configuration (sheet types, editor tools, party types)
 * for the authenticated user's plan.
 * @returns {Promise<{ disciplines, userPlanId, userPlanCode }>}
 */
export async function fetchDisciplineConfig() {
  const res = await fetch(`${API}/disciplines/config`, {
    headers: authHeaders(),
  });
  if (!res.ok) {
    const msg = await res.text().catch(() => '');
    throw new Error(`Disiplin config yüklenemedi: ${res.status} ${msg}`);
  }
  return res.json();
}
